import * as Debug from "debug";

import { GlobalConfig } from "./config";

Debug.enable("*");

const LEVELS = {
    log: "blue",
    error: "red",
    info: "green"
}


class InternalLogger {
    constructor(scope: string) {
        this.scope = scope;
    }

    private scope: string;

    public log(message: string | object, force: boolean = false) {
        this.writeMessage("log", message, force)

    }

    public error(message: string | object, force: boolean = false) {
        this.writeMessage("error", message, force)
    }

    public info(message: string | object, force: boolean = false) {
        this.writeMessage("info", message, force)
    }

    public withColor(color: string, message: string | object, force: boolean = false) {
        this.writeMessage(color, message, force);
    }

    private writeMessage(level: string, message: string | object, force: boolean) {
        if(!GlobalConfig.debug && !force) return;

        const name = this.scope === "" ? `[${GlobalConfig.appName}]` : `[${GlobalConfig.appName}][${this.scope}]`;

        const formatter = typeof message === "string" ? "%s" : "%o";

        const debug: any = Debug(name);

        debug.color = LEVELS[level] || level;

        debug(formatter, message);
    }
}

const defaultLogger = new InternalLogger("");

export const Logger: InternalLogger = defaultLogger;
export const CreateLogger = (scope: string) => new InternalLogger(scope);
